<template>
  <b-modal
    size="lg"
    button-size="sm"
    v-model="showModal"
    :title="title"
    hide-footer
    @hidden="cancelar"
  >
    <b-container>
      <b-row>
        <b-col>
          <b-form @submit.prevent="submitForm">
            <lg-form-const-select
              v-model="form.tipoPessoa"
              label="Tipo de Pessoa: *"
              :options="tiposPessoa"
              required
            ></lg-form-const-select>

            <div v-if="form.tipoPessoa">
              <lg-form-input
                v-model="form.nome"
                label="Nome: *"
                required
              ></lg-form-input>

              <lg-form-input
                v-model="form.cargo"
                label="Cargo: *"
                required
              ></lg-form-input>

              <lg-form-input
                invalidFeedback="Informe um CPF válido!"
                description=" "
                required
                v-model="form.cpf"
                label="CPF: *"
                :error="cpfValidation"
                :formatter="cpfFormatter"
              ></lg-form-input>

              <lg-form-input
                v-if="form.tipoPessoa === 'SOCIO'"
                v-model="form.percentualParticipacao"
                label="Percentual de Participação:"
                type="text"
                @input="handlePercentInput"
                :formatter="percentFormatter"
              ></lg-form-input>

              <b-row>
                <b-col>
                  <lg-form-input
                    v-model="form.dataInicio"
                    label="Data de Início:"
                    type="date"
                  ></lg-form-input>
                </b-col>
                <b-col>
                  <lg-form-input
                    v-model="form.dataFim"
                    label="Data de Fim:"
                    type="date"
                  ></lg-form-input>
                </b-col>
              </b-row>
            </div>

            <div v-if="form.tipoPessoa === 'PROCURADOR'">
              <h5 class="mt-3">Dados do Procurador</h5>

              <lg-form-const-select
                v-model="form.tipoProcuracao"
                label="Tipo de Procuração: *"
                :options="tiposProcuracao"
                required
              ></lg-form-const-select>

              <lg-form-input
                v-model="form.dataValidadeProcuracao"
                label="Data de Validade da Procuração:"
                type="date"
              ></lg-form-input>

              <b-form-group label="Poderes:">
                <b-form-checkbox v-model="form.podeRepresentarAdministracao">
                  Pode representar administração
                </b-form-checkbox>
                <b-form-checkbox v-model="form.podeAssinarContratos">
                  Pode assinar contratos
                </b-form-checkbox>
                <b-form-checkbox v-model="form.podeAssinarNotasFiscais">
                  Pode assinar notas fiscais
                </b-form-checkbox>
                <b-form-checkbox v-model="form.podeOutrasAcoes">
                  Pode realizar outras ações
                </b-form-checkbox>
              </b-form-group>

              <b-form-row>
                <b-col cols="11" class="text-right">
                  <label v-if="!form.arquivoProcuracao" for="fileInputProcuracao" class="file-label">
                    <img :src="imgClip" class="img img--clickable" alt="icone pdf" />
                  </label>
                  <input v-if="!form.arquivoProcuracao" type="file" id="fileInputProcuracao" @change="carregarDocumentoProcuracao"
                    style="display: none;">
                  <img v-if="form.arquivoProcuracao" :src="imgClip" class="img img--clickable" alt="icone pdf"
                    @click="mensagemErro" />
                </b-col>
              </b-form-row>
              <b-form-row class="mt-1">
                <b-col cols="12">
                  <b-table class="col-12" responsive="sm" stacked="sm" small outlined sticky-header
                    show-empty head-variant="light" :busy="false" :items="form.arquivoProcuracao"
                    :fields="itensFieldsProcuracao">
                    <template #empty>
                      <h6 style="text-align: center">
                      </h6>
                    </template>
                    <template v-slot:cell(edit)>
                      <b-icon class="hand-pointer" @click="apagarProcuracao" icon="trash" font-scale="2" />
                    </template>
                  </b-table>
                </b-col>
              </b-form-row>
            </div>

            <div v-if="form.tipoPessoa === 'RESPONSAVEL_TECNICO'">
              <h5 class="mt-3">Dados do Responsável Técnico</h5>

              <lg-form-input
                v-model="form.formacao"
                label="Formação:"
              ></lg-form-input>

              <lg-form-input
                v-model="form.numRegistroConselho"
                label="Número de Registro no Conselho:"
              ></lg-form-input>

              <lg-form-input
                v-model="form.conselhoProfissional"
                label="Conselho Profissional:"
              ></lg-form-input>

              <b-form-row>
                <b-col cols="11" class="text-right">
                  <label v-if="!form.arquivoResponsavelTecnico" for="fileInputResponsavelTecnico" class="file-label">
                    <img :src="imgClip" class="img img--clickable" alt="icone pdf" />
                  </label>
                  <input v-if="!form.arquivoResponsavelTecnico" type="file" id="fileInputResponsavelTecnico" @change="carregarDocumentoResponsavelTecnico"
                    style="display: none;">
                  <img v-if="form.arquivoResponsavelTecnico" :src="imgClip" class="img img--clickable" alt="icone pdf"
                    @click="mensagemErro" />
                </b-col>
              </b-form-row>
              <b-form-row class="mt-1">
                <b-col cols="12">
                  <b-table class="col-12" responsive="sm" stacked="sm" small outlined sticky-header
                    show-empty head-variant="light" :busy="false" :items="form.arquivoResponsavelTecnico"
                    :fields="itensFieldsResponsavelTecnico">
                    <template #empty>
                      <h6 style="text-align: center">
                      </h6>
                    </template>
                    <template v-slot:cell(edit)>
                      <b-icon class="hand-pointer" @click="apagarResponsavelTecnico" icon="trash" font-scale="2" />
                    </template>
                  </b-table>
                </b-col>
              </b-form-row>
            </div>

            <div v-if="form.tipoPessoa === 'PREPOSTO'">
              <h5 class="mt-3">Dados do Preposto</h5>

              <lg-form-input
                v-model="form.cargoFuncao"
                label="Cargo/Função:"
              ></lg-form-input>

              <lg-form-input
                v-model="form.setorAtuacao"
                label="Setor de Atuação:"
              ></lg-form-input>

              <b-form-row>
                <b-col cols="11" class="text-right">
                  <label v-if="!form.arquivoDesignacao" for="fileInputDesignacao" class="file-label">
                    <img :src="imgClip" class="img img--clickable" alt="icone pdf" />
                  </label>
                  <input v-if="!form.arquivoDesignacao" type="file" id="fileInputDesignacao" @change="carregarDocumentoDesignacao"
                    style="display: none;">
                  <img v-if="form.arquivoDesignacao" :src="imgClip" class="img img--clickable" alt="icone pdf"
                    @click="mensagemErro" />
                </b-col>
              </b-form-row>
              <b-form-row class="mt-1">
                <b-col cols="12">
                  <b-table class="col-12" responsive="sm" stacked="sm" small outlined sticky-header
                    show-empty head-variant="light" :busy="false" :items="form.arquivoDesignacao"
                    :fields="itensFieldsPreposto">
                    <template #empty>
                      <h6 style="text-align: center">
                      </h6>
                    </template>
                    <template v-slot:cell(edit)>
                      <b-icon class="hand-pointer" @click="apagarDesignacao" icon="trash" font-scale="2" />
                    </template>
                  </b-table>
                </b-col>
              </b-form-row>
            </div>

            <div v-if="form.tipoPessoa">
              <b-form-radio-group
                size="sm"
                v-model="form.situacao"
                :options="options"
                name="situacao-options"
                class="d-flex mt-3"
              >
              </b-form-radio-group>
              <div class="d-flex justify-content-center mt-3">
                <b-button
                  type="submit"
                  variant="success"
                  style="height: 30px"
                  pill
                  size="sm"
                >
                  <div>
                    <b-icon icon="check-circle" />
                  </div>
                </b-button>
                <b-button
                  class="ml-2"
                  @click="cancelar"
                  style="height: 30px"
                  pill
                  size="sm"
                  variant="danger"
                >
                  <div>
                    <b-icon icon="x-circle" />
                  </div>
                </b-button>
              </div>
            </div>
          </b-form>
        </b-col>
      </b-row>
    </b-container>
  </b-modal>
</template>

<script>
import LgFormInput from "@/core/components/Form/LgFormInput.vue";
import LgFormConstSelect from "@/core/components/Form/LgFormConstSelect.vue";
import ConfirmMixin from "@/core/mixins/confirm";
import ResourceService from "@/core/api/ResourceService";
import { FormResourceMixin } from "@/core/mixins/resource";
import { isCpfValid, cpfFormatter } from "@/utils/cpfUtils";
import ClipIcon from "@/core/assets/icons/clip.png";

export default {
  components: {
    LgFormInput,
    LgFormConstSelect,
  },
  data() {
    return {
      showModal: true,
      cpfValido: false,
      imgClip: ClipIcon,
      itensFieldsProcuracao: [
        {
          key: 'titulo', label: 'Arquivo da Procuração',
          thStyle: "font-size: 14px; font-weight: 400;",
          tdStyle: "font-size: 13px",
        },
        {
          key: 'edit', label: ' ',
          thStyle: "font-size: 14px; font-weight: 400;",
          tdStyle: "font-size: 13px",
        },
      ],
      itensFieldsResponsavelTecnico: [
        {
          key: 'titulo', label: 'Arquivo do Responsável Técnico',
          thStyle: "font-size: 14px; font-weight: 400;",
          tdStyle: "font-size: 13px",
        },
        {
          key: 'edit', label: ' ',
          thStyle: "font-size: 14px; font-weight: 400;",
          tdStyle: "font-size: 13px",
        },
      ],
      itensFieldsPreposto: [
        {
          key: 'titulo', label: 'Arquivo de Designação',
          thStyle: "font-size: 14px; font-weight: 400;",
          tdStyle: "font-size: 13px",
        },
        {
          key: 'edit', label: ' ',
          thStyle: "font-size: 14px; font-weight: 400;",
          tdStyle: "font-size: 13px",
        },
      ],
      options: [
        { text: "Ativo", value: "1" },
        { text: "Inativo", value: "0" },
      ],
      form: {
        nome: "",
        cargo: "",
        cpf: "",
        codEmpresa: null,
        situacao: 1,
        tipoPessoa: null,
        // Campos comuns
        percentualParticipacao: null,
        dataInicio: null,
        dataFim: null,
        // Campos para Procurador
        tipoProcuracao: null,
        dataValidadeProcuracao: null,
        podeRepresentarAdministracao: false,
        podeAssinarContratos: false,
        podeAssinarNotasFiscais: false,
        podeOutrasAcoes: false,
        arquivoProcuracao: null,
        // Campos para Responsável Técnico
        formacao: "",
        numRegistroConselho: "",
        conselhoProfissional: "",
        arquivoResponsavelTecnico: null,
        // Campos para Preposto
        cargoFuncao: "",
        setorAtuacao: "",
        arquivoDesignacao: null,
      },
      tiposPessoa: [
        { value: "SOCIO", text: "Sócio" },
        { value: "ADMINISTRADOR", text: "Administrador" },
        { value: "PROCURADOR", text: "Procurador" },
        { value: "RESPONSAVEL_TECNICO", text: "Responsável Técnico" },
        { value: "PREPOSTO", text: "Preposto" }
      ],
      tiposProcuracao: [
        { value: "PUBLICA", text: "Pública" },
        { value: "PARTICULAR", text: "Particular" }
      ],
    };
  },
  mixins: [ConfirmMixin, FormResourceMixin],
  props: {
    prefix: {
      type: Array,
      required: true,
    },
    id: {
      type: Number,
      default: null,
    },
    codEmpresa: {
      type: Number,
      required: true,
    },
  },
  watch: {
    'form.tipoPessoa'(newValue, oldValue) {
      if (oldValue && newValue !== oldValue) {
        if (oldValue === 'PROCURADOR') {
          this.form.tipoProcuracao = null;
          this.form.dataValidadeProcuracao = null;
          this.form.podeRepresentarAdministracao = false;
          this.form.podeAssinarContratos = false;
          this.form.podeAssinarNotasFiscais = false;
          this.form.podeOutrasAcoes = false;
        } else if (oldValue === 'RESPONSAVEL_TECNICO') {
          this.form.formacao = '';
          this.form.numRegistroConselho = '';
          this.form.conselhoProfissional = '';
        } else if (oldValue === 'PREPOSTO') {
          this.form.cargoFuncao = '';
          this.form.setorAtuacao = '';
        }
      }
    },
  },
  async beforeMount() {
    this.$service = new ResourceService(`/api/socio-empresa`);
    this.arquivoService = new ResourceService('/api/arquivos');
    this.form.codEmpresa = this.codEmpresa;
    if (this.id) {
      const { data } = await this.$service.findById(this.id);

      this.form = {
        ...this.form,
        ...data,
        podeRepresentarAdministracao: data.podeRepresentarAdministracao === true,
        podeAssinarContratos: data.podeAssinarContratos === true,
        podeAssinarNotasFiscais: data.podeAssinarNotasFiscais === true,
        podeOutrasAcoes: data.podeOutrasAcoes === true
      };

      if (data.codArquivoProcuracao) {
        try {
          const { data: arquivo } = await this.arquivoService.findById(data.codArquivoProcuracao);
          let displayName = arquivo.nome;
          if (displayName.toLowerCase().includes('blob')) {
            displayName = "ARQUIVO_" + this.form.tipoPessoa + ".pdf";
          }
          this.form.arquivoProcuracao = [{
            titulo: displayName,
            id: arquivo.id,
            isExistingFile: true
          }];
        } catch (error) {
          this.$notify({
            type: "danger",
            message: error.response.data
          });
          return;
        }
      }

      if (data.codArquivoDocumentoResponsavelTecnico) {
        try {
          const { data: arquivo } = await this.arquivoService.findById(data.codArquivoDocumentoResponsavelTecnico);
          let displayName = arquivo.nome;
          if (displayName.toLowerCase().includes('blob')) {
            displayName = "ARQUIVO_" + this.form.tipoPessoa + ".pdf";
          }
          this.form.arquivoResponsavelTecnico = [{
            titulo: displayName,
            id: arquivo.id,
            isExistingFile: true
          }];
        } catch (error) {
          this.$notify({
            type: "danger",
            message: error.response.data
          });
          return;
        }
      }

      if (data.codArquivoDocumentoDesignacao) {
        try {
          const { data: arquivo } = await this.arquivoService.findById(data.codArquivoDocumentoDesignacao);
          let displayName = arquivo.nome;
          if (displayName.toLowerCase().includes('blob')) {
            displayName = "ARQUIVO_" + this.form.tipoPessoa + ".pdf";
          }
          this.form.arquivoDesignacao = [{
            titulo: displayName,
            id: arquivo.id,
            isExistingFile: true
          }];
        } catch (error) {
          this.$notify({
            type: "danger",
            message: error.response.data
          });
          return;
        }
      }
    }
  },
  computed: {
    updatedPrefix() {
      return [...this.prefix, "Cadastro"];
    },
    title() {
      return this.updatedPrefix.join(" > ");
    },
    cpfValidation() {
      return this.isCpfValid(this.form.cpf);
    },
  },
  methods: {
    isCpfValid(cpf) {
      const result = isCpfValid(cpf);
      this.cpfValido = !result.$error;
      return result;
    },
    cpfFormatter(value) {
      return cpfFormatter(value);
    },
    percentFormatter(value) {
      if (value === null || value === undefined || value === '') {
        return '';
      }

      if (typeof value === 'string') {
        const parts = value.split('.');
        if (parts.length === 2) {
          if (parts[1] === '' || parts[1].length < 2) {
            return value + '%';
          }
        }
      }

      return parseFloat(value).toFixed(2) + '%';
    },
    handlePercentInput(value) {
      const numericValue = value.replace(/[^\d.]/g, '');

      const parts = numericValue.split('.');
      let formattedValue = parts[0];

      if (parts.length > 1) {
        formattedValue += '.' + parts[1].substring(0, 2);
      }

      this.form.percentualParticipacao = formattedValue ? parseFloat(formattedValue) : null;
    },
    mensagemErro() {
      this.$notify({
        type: "danger",
        message: 'Não é possível anexar dois documentos',
      });
    },
    carregarDocumentoProcuracao(event) {
      if (this.form.arquivoProcuracao) {
        this.mensagemErro();
        return;
      }

      var file = event.target.files[0];

      if (file) {

        var nomeArquivo = file.name;
        var reader = new FileReader();
        reader.onload = (e) => {
          this.form.arquivoProcuracao = [{ titulo: nomeArquivo, file: e.target.result }];
        };
        reader.readAsDataURL(file);
      }
    },
    carregarDocumentoResponsavelTecnico(event) {
      if (this.form.arquivoResponsavelTecnico) {
        this.mensagemErro();
        return;
      }

      var file = event.target.files[0];

      if (file) {
        if (file.type !== 'application/pdf' || !file.name.toLowerCase().endsWith('.pdf')) {
          this.$notify({
            type: "danger",
            message: "Apenas arquivos PDF são permitidos."
          });
          event.target.value = '';
          return;
        }

        var nomeArquivo = file.name;
        var reader = new FileReader();
        reader.onload = (e) => {
          this.form.arquivoResponsavelTecnico = [{ titulo: nomeArquivo, file: e.target.result }];
        };
        reader.readAsDataURL(file);
      }
    },
    carregarDocumentoDesignacao(event) {
      if (this.form.arquivoDesignacao) {
        this.mensagemErro();
        return;
      }

      var file = event.target.files[0];

      if (file) {
        if (file.type !== 'application/pdf' || !file.name.toLowerCase().endsWith('.pdf')) {
          this.$notify({
            type: "danger",
            message: "Apenas arquivos PDF são permitidos."
          });
          event.target.value = '';
          return;
        }

        var nomeArquivo = file.name;
        var reader = new FileReader();
        reader.onload = (e) => {
          this.form.arquivoDesignacao = [{ titulo: nomeArquivo, file: e.target.result }];
        };
        reader.readAsDataURL(file);
      }
    },
    async apagarProcuracao() {
      if (this.form.arquivoProcuracao && this.form.arquivoProcuracao[0].isExistingFile) {
        const confirmed = await this.$confirm(
          "Deseja excluir este arquivo?",
          "Excluir arquivo"
        );

        if (!confirmed) {
          return;
        }

        try {
          const fileId = this.form.arquivoProcuracao[0].id;
          await this.arquivoService.remove(fileId);

          this.form.codArquivoProcuracao = null;

          this.$notify({
            type: "success",
            message: "Arquivo excluído com sucesso"
          });
        } catch (error) {
          this.$notify({
            type: "danger",
            message: error.response.data
          });
          return;
        }
      }

      this.form.arquivoProcuracao = null;
    },
    async apagarResponsavelTecnico() {
      if (this.form.arquivoResponsavelTecnico && this.form.arquivoResponsavelTecnico[0].isExistingFile) {
        const confirmed = await this.$confirm(
          "Deseja excluir este arquivo?",
          "Excluir arquivo"
        );

        if (!confirmed) {
          return;
        }

        try {
          const fileId = this.form.arquivoResponsavelTecnico[0].id;
          await this.arquivoService.remove(fileId);

          this.form.codArquivoDocumentoResponsavelTecnico = null;

          this.$notify({
            type: "success",
            message: "Arquivo excluído com sucesso"
          });
        } catch (error) {
          this.$notify({
            type: "danger",
            message: error.response.data
          });
          return;
        }
      }

      this.form.arquivoResponsavelTecnico = null;
    },
    async apagarDesignacao() {
      if (this.form.arquivoDesignacao && this.form.arquivoDesignacao[0].isExistingFile) {
        const confirmed = await this.$confirm(
          "Deseja excluir este arquivo?",
          "Excluir arquivo"
        );

        if (!confirmed) {
          return;
        }

        try {
          const fileId = this.form.arquivoDesignacao[0].id;
          await this.arquivoService.remove(fileId);

          this.form.codArquivoDocumentoDesignacao = null;

          this.$notify({
            type: "success",
            message: "Arquivo excluído com sucesso"
          });
        } catch (error) {
          this.$notify({
            type: "danger",
            message: error.response.data
          });
          return;
        }
      }

      this.form.arquivoDesignacao = null;
    },
    dataURItoBlob(dataURI) {
      var byteString = atob(dataURI.split(',')[1]);
      var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
      var ab = new ArrayBuffer(byteString.length);
      var ia = new Uint8Array(ab);
      for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }
      var blob = new Blob([ab], { type: mimeString });
      return blob;
    },

    async submitForm() {
      if (!this.cpfValido) {
        this.$notify({
          type: "danger",
          message: "Preencha um cpf válido!",
        });
        return;
      }

      if (!this.form.nome || !this.form.cargo || !this.form.tipoPessoa) {
        this.$notify({
          type: "danger",
          message: "Preencha todos os campos obrigatórios!",
        });
        return;
      }

      if (this.form.tipoPessoa === 'PROCURADOR' && !this.form.tipoProcuracao) {
        this.$notify({
          type: "danger",
          message: "Selecione o tipo de procuração!",
        });
        return;
      }

      try {
        const formToSave = { ...this.form };

        if (this.form.tipoPessoa !== 'PROCURADOR') {
          formToSave.tipoProcuracao = null;
          formToSave.dataValidadeProcuracao = null;
          formToSave.podeRepresentarAdministracao = false;
          formToSave.podeAssinarContratos = false;
          formToSave.podeAssinarNotasFiscais = false;
          formToSave.podeOutrasAcoes = false;
          formToSave.arquivoProcuracao = null;
        }

        if (this.form.tipoPessoa !== 'RESPONSAVEL_TECNICO') {
          formToSave.formacao = null;
          formToSave.numRegistroConselho = null;
          formToSave.conselhoProfissional = null;
          formToSave.arquivoResponsavelTecnico = null;
        }

        if (this.form.tipoPessoa !== 'PREPOSTO') {
          formToSave.cargoFuncao = null;
          formToSave.setorAtuacao = null;
          formToSave.arquivoDesignacao = null;
        }

        const hasNewFiles = (
          (this.form.tipoPessoa === 'PROCURADOR' && this.form.arquivoProcuracao && !this.form.arquivoProcuracao[0].isExistingFile) ||
          (this.form.tipoPessoa === 'RESPONSAVEL_TECNICO' && this.form.arquivoResponsavelTecnico && !this.form.arquivoResponsavelTecnico[0].isExistingFile) ||
          (this.form.tipoPessoa === 'PREPOSTO' && this.form.arquivoDesignacao && !this.form.arquivoDesignacao[0].isExistingFile)
        );

        const hasExistingFiles = (
          (this.form.tipoPessoa === 'PROCURADOR' && this.form.arquivoProcuracao && this.form.arquivoProcuracao[0].isExistingFile) ||
          (this.form.tipoPessoa === 'RESPONSAVEL_TECNICO' && this.form.arquivoResponsavelTecnico && this.form.arquivoResponsavelTecnico[0].isExistingFile) ||
          (this.form.tipoPessoa === 'PREPOSTO' && this.form.arquivoDesignacao && this.form.arquivoDesignacao[0].isExistingFile)
        );

        if (hasExistingFiles) {
          if (this.form.tipoPessoa === 'PROCURADOR' && this.form.arquivoProcuracao && this.form.arquivoProcuracao[0].isExistingFile) {
            formToSave.codArquivoProcuracao = this.form.arquivoProcuracao[0].id;
          }

          if (this.form.tipoPessoa === 'RESPONSAVEL_TECNICO' && this.form.arquivoResponsavelTecnico && this.form.arquivoResponsavelTecnico[0].isExistingFile) {
            formToSave.codArquivoDocumentoResponsavelTecnico = this.form.arquivoResponsavelTecnico[0].id;
          }

          if (this.form.tipoPessoa === 'PREPOSTO' && this.form.arquivoDesignacao && this.form.arquivoDesignacao[0].isExistingFile) {
            formToSave.codArquivoDocumentoDesignacao = this.form.arquivoDesignacao[0].id;
          }
        }

        if (hasNewFiles) {
          const arquivoService = new ResourceService('/api/arquivos');

          if (this.form.tipoPessoa === 'PROCURADOR' && this.form.arquivoProcuracao && !this.form.arquivoProcuracao[0].isExistingFile) {
            const fileFormData = new FormData();
            fileFormData.append("file", this.dataURItoBlob(this.form.arquivoProcuracao[0].file));
            fileFormData.append("caminho", "procuracao");

            try {
              const { data: arquivoProcuracao } = await arquivoService.saveFormData(null, fileFormData);
              formToSave.codArquivoProcuracao = arquivoProcuracao.id;
            } catch (error) {
              throw error.response.data;
            }
          }

          if (this.form.tipoPessoa === 'RESPONSAVEL_TECNICO' && this.form.arquivoResponsavelTecnico && !this.form.arquivoResponsavelTecnico[0].isExistingFile) {
            const fileFormData = new FormData();
            fileFormData.append("file", this.dataURItoBlob(this.form.arquivoResponsavelTecnico[0].file));
            fileFormData.append("caminho", "responsavel-tecnico");

            try {
              const { data: arquivoResponsavelTecnico } = await arquivoService.saveFormData(null, fileFormData);
              formToSave.codArquivoDocumentoResponsavelTecnico = arquivoResponsavelTecnico.id;
            } catch (error) {
              throw error.response.data;
            }
          }

          if (this.form.tipoPessoa === 'PREPOSTO' && this.form.arquivoDesignacao && !this.form.arquivoDesignacao[0].isExistingFile) {
            const fileFormData = new FormData();
            fileFormData.append("file", this.dataURItoBlob(this.form.arquivoDesignacao[0].file));
            fileFormData.append("caminho", "designacao");

            try {
              const { data: arquivoDesignacao } = await arquivoService.saveFormData(null, fileFormData);
              formToSave.codArquivoDocumentoDesignacao = arquivoDesignacao.id;
            } catch (error) {
              throw error.response.data;
            }
          }
        }

        formToSave.arquivoProcuracao = null;
        formToSave.arquivoResponsavelTecnico = null;
        formToSave.arquivoDesignacao = null;

        try {
          await this.$service.save(formToSave);
        } catch (error) {
          throw error.response.data;
        }

        this.$notify({
          type: "success",
          message: 'Registro salvo com sucesso'
        });
        this.cancelar();

      } catch (error) {
        this.$notify({
          type: "danger",
          message: error.response.data
        });
        return;
      }
    },

    cancelar() {
      this.$emit("fechar");
    },
  },
};
</script>

<style>
.hand-pointer {
  cursor: pointer;
}
</style>
